export const GOOGLE_MAPS_API_OPTIONS = {
  id: 'google-map-script', // Must be the same across all uses
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY, // or hardcoded key
  libraries: ['places'],
  version: 'weekly',
  language: 'en',
  region: 'IN',
};
